module.exports = __webpack_public_path__ + "img/consultant03.7ca23585.jpg";